<template>
    <div style="min-height: 200px;" v-loading="loading" element-loading-text="查询中..." v-cloak>
        <div class="search-layout" :class="{'pop-mini' : searchSize == 'mini'}" v-if="enableSearch != null && enableSearch == true">
            <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler" :onConfigReady="onQueryConfigReady"></swb-query-sort-area>
        </div>
        <div class="org-tree">
            <el-tree ref="categTree" :data="dataList" :load="loadNode" lazy="" node-key="id" :filter-node-method="filterNode" :highlight-current="highlightCurrent" :props="defaultProps" :render-content="renderContent"
                     :default-expanded-keys="defaultExpandedKeys"></el-tree>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, filterByName, Routes, MsgBox} from '../../app.vues'
    import {loadgetRetailerBizFormList, loadRetailerMgmtAreaTree, loadRetailerShopTagList} from '../retailer/asset-comn';
    import {openComDetailDlg} from './selectDlg'
    import retailerApi from '../../api/retailer'
    import {isSysRescFrozenIsAllowed} from '../index'
    import SwbOrgTreeSortSet from './orgTreeSortSet'

    Vue.regist(SwbOrgTreeSortSet);

    let mockConfigData = {
        'queryFields': [
            {
                'code': 'name',
                'label': '机构名称',
                'type': 'Text',
                'valueType': 'String',
                'basic': true,
                'hidden': false,
                'rptUsed': false,
                'useLikeMatch': true,
                'ctxBindName': null
            },
            {
                'code': 'states',
                'label': '状态',
                'type': 'Select',
                'valueType': 'Integer',
                'value': null,
                'basic': true,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [],
                'multiple': true,
                'firstOnClear': true,
                'firstIsMutex': false,
                'multipleLimit': 0,
                'collapseTags': true
            },
            {
                'code': 'orgTypes',
                'label': '机构类型',
                'type': 'Casc',
                'valueType': 'Integer',
                'value': null,
                'basic': true,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [{
                    value: -1,
                    label: '业务单元',
                    children: [{
                        value: 2,
                        label: '仅门店',
                        leaf: true
                    }, {
                        value: 3,
                        label: '非门店',
                        leaf: true
                    }]
                }, {
                    value: 0,
                    label: '部门',
                    leaf: true
                }],
                'multiple': true
            },
            {
                'code': 'bizFormIds',
                'label': '经营业态',
                'type': 'Select',
                'valueType': 'Integer',
                'value': null,
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [],
                'multiple': true
            },
            {
                'code': 'tagIds',
                'label': '标签',
                'type': 'Select',
                'valueType': 'String',
                'value': null,
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'dataList': [],
                'multiple': true
            },
            {
                'code': 'mgmtSmlAreaIds',
                'label': '管理区域',
                'type': 'Casc',
                'valueType': 'Integer',
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'ctxBindName': null,
                'multiple': true,
                'dataList': []
            },
            {
                'code': 'fiscalSubjectCode',
                'label': '财务主体代码',
                'type': 'Text',
                'valueType': 'String',
                'basic': false,
                'hidden': false,
                'rptUsed': false,
                'useLikeMatch': true,
                'ctxBindName': null
            }
        ],
        'sortFields': [
            {
                'code': 'createTime',
                'label': '创建时间',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'name',
                'label': '名称',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'no',
                'label': '机构编号',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'openedTime',
                'label': '实际开业时间',
                'order': 'desc',
                'enabled': false
            },
            {
                'code': 'closedTime',
                'label': '实际闭店时间',
                'order': 'desc',
                'enabled': false
            }
        ]
    };

    export default {
        name: 'swb-retailer-com-tree-multi-select',
        desc: '机构树列表 - 多选(支持三级，现在最少最后一级可被选择，可自定义第一级和第二级)',
        props: {
            enableSearch: {
                type: Boolean,
                default: true
            },
            showCheckboxLevel1: { // 第一级节点是否可被选择，默认否
                type: Boolean,
                default: false
            },
            showCheckboxLevel2: { // 第二级节点是否可被选择，默认否
                type: Boolean,
                default: false
            },
            showCheckboxLevel3: { // 第三级节点是否可被选择，默认否
                type: Boolean,
                default: false
            },
            checkStrictly: { //TODO 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false，相互关联只支持下级节点禁用
                type: Boolean,
                deafult: false,
            },
            defaultCheckedItems: {// 回显的数据ids
                type: Array,
                default: function () {
                    return [];
                }
            },
            model: { // 数据模型
                type: Object,
                default: function () {
                    let model = {};
                    model.comIdColumn = "comId"; //
                    model.comNameColumn = "comName";
                    model.comBizUnitNameColumn = "bizUnitName";
                    model.comFullNameColumn = "fullName";
                    model.comLevelColumn = "comLevel";
                    model.comBizFormIdColumn = "bizFormId";
                    model.comBizAreaIdColumn = "bizAreaId";
                    return model;
                }
            },
            bizDepart: {
                type: Boolean,
                default: false
            },
            bizUnitId: {
                type: Number,
                default: null
            },
            usableRealComIds: { // 可用的实体公司ids，不传时全部可用
                type: Array,
                default: []
            },
            optionalState: { // 可选的state
                type: Array,
                default: function () {
                    return [1, 3, 4];
                }
            },
            defalultState: { // 默认选中的state
                type: Array,
                default: function () {
                    return [1, 3]
                }
            },
        },
        watch: {},
        data: function () {
            return {
                loading: false,
                highlightCurrent: true,
                dataList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                defaultExpandedKeys: [],
                checkComIds: [],
                checkComList: [],
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {
                        states: [1, 3]
                    },
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            let model = this.model;
            //
            let defaultCheckedItems = this.defaultCheckedItems;
            //
            let comIds = defaultCheckedItems.pluck(model.comIdColumn);
            this.checkComIds = comIds;
            this.checkComList = defaultCheckedItems;
            //
            let comId1s = defaultCheckedItems.pluck(model.comIdColumn + 1);
            let comId2s = defaultCheckedItems.pluck(model.comIdColumn + 2);
            let comId3s = defaultCheckedItems.pluck(model.comIdColumn + 3);
            this.defaultExpandedKeys = comId1s.concat(comId2s).concat(comId3s);
            //
            this.queryConfig = Utils.merge({}, mockConfigData);
            this.queryModel.filterItems.states = Utils.merge([], this.defalultState);
        },
        methods: {
            onQueryConfigReady: function (event) {
                let self = this;
                // 业态
                loadgetRetailerBizFormList(function (dataList) {
                    self.updateQueryModelField('bizFormIds', dataList);
                });
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField('tagIds', dataList);
                }, true);
                // 管理区域
                loadRetailerMgmtAreaTree(this.retailerId, function (dataList) {
                    self.updateQueryModelField('mgmtSmlAreaIds', dataList);
                });
                // 机构状态
                let dataList = [];
                let dataValue = [];
                let stateMap = {
                    0: '筹备中',
                    1: '营业中',
                    3: '计划停业',
                    4: '已停业'
                };
                let optionalState = this.optionalState;
                let defalultState = this.defalultState;
                optionalState.forEach(function (state) {
                    dataList.push({
                        'label': stateMap[state],
                        'value': state
                    });
                    if (defalultState.indexOf(state) > -1) {
                        dataValue.push(state);
                    }
                });
                self.updateQueryModelField('states', dataList, dataValue);
            },
            updateQueryModelField: function (itemCode, dataList = [], dataValue) {
                let self = this;
                if (itemCode != null) {
                    setTimeout(function () {
                        let query_model_ctrl = self.$refs['query_model_ctrl'];
                        let data = {
                            dataList: dataList
                        };
                        if (!Utils.isNoB(dataValue)) {
                            data.value = dataValue;
                        }
                        let fieldInfo = {};
                        fieldInfo[itemCode] = data;
                        query_model_ctrl.updateFields(fieldInfo);
                    }, 500);
                }
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                if (this.bizDepart) {
                    this.handleFilterTextClickOrg(queryModel);
                } else {
                    this.handleFilterTextClickBizUnit(queryModel);
                }
            },
            handleFilterTextClickOrg: function (queryModel) {
                // 含部门机构树过滤
                let self = this;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if ((Utils.isNoB(filterItems.name) || filterItems.name.length == 0) && //
                    (Utils.isNoB(filterItems.states) || filterItems.states.length == 0) && //
                    (Utils.isNoB(filterItems.orgTypes) || filterItems.orgTypes.length == 0) && //
                    (Utils.isNoB(filterItems.bizFormIds) || filterItems.bizFormIds.length == 0) && //
                    (Utils.isNoB(filterItems.tagIds) || filterItems.tagIds.length == 0) && //
                    (Utils.isNoB(filterItems.mgmtSmlAreaIds) || filterItems.mgmtSmlAreaIds.length == 0) && //
                    (Utils.isNoB(filterItems.fiscalSubjectCode) || filterItems.fiscalSubjectCode.length == 0)
                ) {
                    filterItems.lazyFlag = true;
                } else {
                    filterItems.lazyFlag = false;
                }
                // orgTypes
                if (!Utils.isNoB(filterItems.orgTypes) && filterItems.orgTypes.length > 0) {
                    let orgTypes = filterItems.orgTypes;
                    if (orgTypes.indexOf(2) > -1 || orgTypes.indexOf(3) > -1) {
                        orgTypes.push(1);
                        if (orgTypes.indexOf(2) == -1) {
                            filterItems.shopFlag = false;
                        }
                        if (orgTypes.indexOf(3) == -1) {
                            filterItems.shopFlag = true;
                        }
                    }
                }
                //
                filterItems.isCom = true;
                let theLoad = MsgBox.loading();
                filterItems.bizUnitId = this.bizUnitId || null;
                let sortedFilter = {
                    filterItems: filterItems,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComList(sortedFilter, function (result, jqXhr) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        self.normalizeTreeNode(data);
                        let comList = Utils.merge([], data);
                        //
                        let nodeKey = [];
                        let comIds = result.codeName || null;
                        if (!Utils.isNoB(comIds)) {
                            nodeKey = JSON.decode(comIds) || [];
                        }
                        self.dataList = comList;
                        self.defaultExpandedKeys = Utils.merge([], nodeKey);
                    } else {
                        self.dataList = [];
                        self.$message.error(result.message);
                    }
                });
            },
            handleFilterTextClickBizUnit: function (queryModel) {
                // 不含部门机构树过滤
                let self = this;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if ((Utils.isNoB(filterItems.name) || filterItems.name.length == 0) && //
                    (Utils.isNoB(filterItems.states) || filterItems.states.length == 0) && //
                    (Utils.isNoB(filterItems.orgTypes) || filterItems.orgTypes.length == 0) && //
                    (Utils.isNoB(filterItems.bizFormIds) || filterItems.bizFormIds.length == 0) && //
                    (Utils.isNoB(filterItems.tagIds) || filterItems.tagIds.length == 0) && //
                    (Utils.isNoB(filterItems.mgmtSmlAreaIds) || filterItems.mgmtSmlAreaIds.length == 0) && //
                    (Utils.isNoB(filterItems.fiscalSubjectCode) || filterItems.fiscalSubjectCode.length == 0)
                ) {
                    filterItems.lazyFlag = true;
                } else {
                    filterItems.lazyFlag = false;
                }
                // orgTypes
                if (!Utils.isNoB(filterItems.orgTypes) && filterItems.orgTypes.length > 0) {
                    let orgTypes = filterItems.orgTypes;
                    if (orgTypes.indexOf(2) > -1 || orgTypes.indexOf(3) > -1) {
                        orgTypes.push(1);
                        if (orgTypes.indexOf(2) == -1) {
                            filterItems.shopFlag = false;
                        }
                        if (orgTypes.indexOf(3) == -1) {
                            filterItems.shopFlag = true;
                        }
                    }
                }
                //
                filterItems.isCom = true;
                let theLoad = MsgBox.loading();
                let sortedFilter = {
                    filterItems: filterItems,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComBizUnitList(sortedFilter, function (result, jqXhr) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        self.normalizeTreeNode(data);
                        let comList = Utils.merge([], data);
                        //
                        let nodeKey = [];
                        let comIds = result.codeName || null;
                        if (!Utils.isNoB(comIds)) {
                            nodeKey = JSON.decode(comIds) || [];
                        }
                        self.dataList = comList;
                        self.defaultExpandedKeys = Utils.merge([], nodeKey);
                    } else {
                        self.dataList = [];
                        self.$message.error(result.message);
                    }
                });
            },
            getLazyOrgComList: function (parentId) {
                let self = this;
                let postData = {};
                postData.lazyFlag = true;
                postData.parentId = parentId || null;
                postData.isCom = true;
                postData.bizUnitId = this.bizUnitId || null;
                //
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                    postData.states = filterItems.states;
                }
                let sortedFilter = {
                    filterItems: postData,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComList(sortedFilter, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let dataList = result.data;
                        self.normalizeTreeNode(dataList);
                        //
                        self.mergeCheckComList(dataList);
                        self.dataList = dataList;
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            getLazyBizUnitComList: function (parentId) {
                let self = this;
                let postData = {};
                postData.lazyFlag = true;
                postData.parentBizUnitId = parentId || null;
                postData.isCom = true;
                //
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                    postData.states = filterItems.states;
                }
                let sortedFilter = {
                    filterItems: postData,
                    sortItemList: Utils.merge([], queryModel.sortItemList),
                    sortItems: Utils.merge({}, queryModel.sortItems)
                }
                retailerApi.getRetailerComBizUnitList(sortedFilter, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let dataList = result.data;
                        self.normalizeTreeNode(dataList);
                        //
                        self.mergeCheckComList(dataList);
                        self.dataList = dataList;
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            getLazyComList: function (parentId) {
                if (this.bizDepart) {
                    this.getLazyOrgComList(parentId);
                } else {
                    this.getLazyBizUnitComList(parentId);
                }
            },
            mergeCheckComList: function (dataList) {
                if (dataList != null && dataList.length > 0) {
                    let checkComIds = this.checkComIds;
                    let checkComList = this.checkComList;
                    let model = this.model;
                    //
                    for (let i = 0; i < dataList.length; i++) {
                        let comInfo = dataList[i];
                        if (checkComIds.contains(comInfo.id)) {
                            //
                            let item = checkComList.find(function (elem, index) {
                                return elem[model.comIdColumn] == comInfo.id;
                            });
                            item[model.comNameColumn] = comInfo.name;
                            item[model.comBizUnitNameColumn] = comInfo.bizUnitName;
                            item[model.comFullNameColumn] = comInfo.fullName;
                            item[model.comLevelColumn] = comInfo.level;
                            item[model.comBizFormIdColumn] = comInfo.bizFormId;
                            item[model.comBizAreaIdColumn] = comInfo.bizAreaId;
                            item.shopFlag = comInfo.shopFlag;
                        }
                    }
                }
            },
            loadNodeOrg(node, resolve) {
                let self = this;
                let dbChildren = node.data.children || [];
                if (dbChildren != null && dbChildren.length > 0) {
                    return resolve(dbChildren);
                }
                //
                if (node.level === 0) {
                    this.getLazyComList();
                } else {
                    if (node.level >= 10) {
                        return resolve(dbChildren);
                    }
                    let parentId = node.data.id;
                    let postData = {};
                    postData.lazyFlag = true;
                    postData.parentId = parentId;
                    postData.isCom = true;
                    postData.bizUnitId = this.bizUnitId || null;
                    //
                    let queryModel = this.queryModel;
                    let filterItems = Utils.merge({}, queryModel.filterItems);
                    if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                        postData.states = filterItems.states;
                    }
                    let sortedFilter = {
                        filterItems: postData,
                        sortItemList: Utils.merge([], queryModel.sortItemList),
                        sortItems: Utils.merge({}, queryModel.sortItems)
                    }
                    retailerApi.getRetailerComList(sortedFilter, function (result) {
                        if (result.type == 'info') {
                            self.normalizeTreeNode(result.data);
                            self.mergeCheckComList(result.data);
                            resolve(result.data);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });

                }
            },
            loadNodeBizUnit(node, resolve) {
                let self = this;
                let dbChildren = node.data.children || [];
                if (dbChildren != null && dbChildren.length > 0) {
                    return resolve(dbChildren);
                }
                //
                if (node.level === 0) {
                    this.getLazyComList();
                } else {
                    if (node.level >= 10) {
                        return resolve(dbChildren);
                    }
                    let parentBizUnitId = node.data.bizUnitId;
                    let postData = {};
                    postData.lazyFlag = true;
                    postData.parentBizUnitId = parentBizUnitId;
                    postData.isCom = true;
                    //
                    let queryModel = this.queryModel;
                    let filterItems = Utils.merge({}, queryModel.filterItems);
                    if (!Utils.isNoB(filterItems.states) && filterItems.states.length > 0) {
                        postData.states = filterItems.states;
                    }
                    let sortedFilter = {
                        filterItems: postData,
                        sortItemList: Utils.merge([], queryModel.sortItemList),
                        sortItems: Utils.merge({}, queryModel.sortItems)
                    }
                    retailerApi.getRetailerComBizUnitList(sortedFilter, function (result) {
                        if (result.type == 'info') {
                            self.mergeCheckComList(result.data);
                            resolve(result.data);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                }
            },
            normalizeTreeNode: function (data) {
                Utils.forEachTreeNode(data, function (nodeData) {
                    let nodeId = nodeData['id'] || null;
                    if (nodeId == null) {
                        nodeId = Utils.genUniqueStr();
                    }
                    //
                    nodeData['nodeKey'] = nodeId;
                }, function (treeNode) {
                    let comSons = treeNode.comSons || [];
                    let departs = treeNode.departs || [];
                    let children = departs.concat(comSons);
                    //
                    treeNode.children = children;
                    return children;
                });
            },
            loadNode(node, resolve) {
                if (this.bizDepart) {
                    this.loadNodeOrg(node, resolve);
                } else {
                    this.loadNodeBizUnit(node, resolve);
                }
            },
            filterNode(value, data) {
                if (!value) {
                    return true;
                }
                return data.name.indexOf(value) !== -1;
            },
            renderContent: function (createElement, node) {
                //设置叶子节点标记（不然会出现多余的箭头）
                let leafFlag = node.data.leafFlag;
                if (leafFlag) {
                    let children = node.data.children || [];
                    if (children == null || children.length <= 0) {
                        leafFlag = true;
                    } else {
                        leafFlag = false;
                    }
                }
                node.node.isLeaf = leafFlag;
                //
                let selfTree = this;
                let isAllowed = isSysRescFrozenIsAllowed(selfTree, node.data);
                // node.data.isAllowed = isAllowed;
                return createElement({
                    data: function () {
                        return {
                            item: node,
                            isAllowed: isAllowed,
                            checkComIds: selfTree.checkComIds,
                            checkComList: selfTree.checkComList,
                            showCheckboxLevel1: selfTree.showCheckboxLevel1,
                            showCheckboxLevel2: selfTree.showCheckboxLevel2,
                            showCheckboxLevel3: selfTree.showCheckboxLevel3,
                            checkStrictly: selfTree.checkStrictly,
                            usableRealComIds: selfTree.usableRealComIds
                        };
                    },
                    template: '' +
                        '<span style="width: 100%;">' +
                        '<span style="width: 100%;margin-top:3px;" v-if = "item.data.level == 1">' +
                        '<el-checkbox v-if = "showCheckboxLevel1" :disabled = "(usableRealComIds.length > 0 && usableRealComIds.indexOf(item.data.realComId) == -1) || !isAllowed" :checked = "checkComIds.indexOf(item.data.id) >= 0" @change ="handleCheckedChange(item.data)" :label="item.data.id">' +
                        '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                        '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                        '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                        '{{item.data.name}}</el-checkbox>' +
                        '<span v-else>{{item.data.name}}</span>' +
                        '</span>' +
                        '<span style="width: 100%;margin-top:3px;" v-if = "item.data.level == 2">' +
                        '<el-checkbox v-if = "showCheckboxLevel2" :disabled = "(!checkStrictly && checkComIds.indexOf(item.data.parentId) >= 0) || !isAllowed || (usableRealComIds.length > 0 && usableRealComIds.indexOf(item.data.realComId) == -1)" :checked = "checkComIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">' +
                        '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                        '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                        '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                        '{{item.data.name}}</el-checkbox>' +
                        '<span v-else>{{item.data.name}}</span>' +
                        '<el-tag type="danger" v-if="item.data.state == 0">筹备中</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 3">计划停业</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 4">已停业</el-tag>' +
                        '<el-tag type="success" v-if="item.data.shopFlag && item.data.tagId != null">{{item.data.tagName}}</el-tag>' +
                        '</span>' +
                        '<span style="width: 100%;margin-top:3px;" v-if = "item.data.level == 3">' +
                        '<el-checkbox v-if = "showCheckboxLevel3" :disabled = "!checkStrictly && (checkComIds.indexOf(item.data.parentId) >= 0 || !isAllowed || checkComIds.indexOf(item.data.comId1) >= 0) || (usableRealComIds.length > 0 && usableRealComIds.indexOf(item.data.realComId) == -1)" :checked = "checkComIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">' +
                        '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                        '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                        '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                        '{{item.data.name}}' +
                        '<el-tag type="danger" v-if="item.data.state == 0">筹备中</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 3">计划停业</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 4">已停业</el-tag>' +
                        '<el-tag type="success" v-if="item.data.shopFlag && item.data.tagId != null">{{item.data.tagName}}</el-tag>' +
                        '</el-checkbox>' +
                        '</span>' +
                        '<span style="width: 100%;margin-top:3px;" v-else-if = "item.data.level >= 4">' +
                        '<el-checkbox :disabled = "!checkStrictly && (checkComIds.indexOf(item.data.parentId) >= 0 || !isAllowed || checkComIds.indexOf(item.data.comId1) >= 0 || checkComIds.indexOf(item.data.comId2) >= 0) || (usableRealComIds.length > 0 && usableRealComIds.indexOf(item.data.realComId) == -1)" :checked = "checkComIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">' +
                        '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                        '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                        '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                        '{{item.data.name}}</el-checkbox>' +
                        '<el-tag type="danger" v-if="item.data.state == 0">筹备中</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 3">计划停业</el-tag>' +
                        '<el-tag type="danger" v-if="item.data.state == 4">已停业</el-tag>' +
                        '<el-tag type="success" v-if="item.data.shopFlag && item.data.tagId != null">{{item.data.tagName}}</el-tag>' +
                        '</span>' +
                        '<span v-if="item.data.orgType != null" class="el-icon-document fr mr5" @click="showDetail($event, item.data.id)"></span>' +
                        '</span>',
                    methods: {
                        handleCheckedChange: function (value) {
                            let model = selfTree.model;
                            //
                            let checkComIds = selfTree.checkComIds;
                            let checkComList = selfTree.checkComList;
                            //
                            if (checkComIds.indexOf(value.id) >= 0) {
                                checkComIds.remove(value.id);
                                //
                                let item = checkComList.find(function (elem, index) {
                                    return elem[model.comIdColumn] == value.id;
                                });
                                checkComList.remove(item);
                            } else {
                                checkComIds.push(value.id);
                                //
                                let item = {};
                                item[model.comIdColumn] = value.id;
                                item[model.comNameColumn] = value.name;
                                item[model.comLevelColumn] = value.level;
                                item[model.comBizFormIdColumn] = value.bizFormId;
                                item[model.comBizAreaIdColumn] = value.bizAreaId;
                                item[model.comBizUnitNameColumn] = value.bizUnitName;
                                item[model.comFullNameColumn] = value.fullName;
                                item.contactName = value.contactName;
                                item.contactTel = value.contactTel;
                                item.contactEmail = value.contactEmail;
                                item.shopFlag = value.shopFlag;
                                item.realComId = value.realComId;
                                item.realComName = value.realComName;
                                checkComList.push(item);
                                // console.log(item);
                                // 删除下级选中
                                let checkStrictly = selfTree.checkStrictly;
                                if (!checkStrictly && value.level <= 2) {
                                    for (let i = 0; i < checkComList.length; i++) {
                                        let checkedCat = checkComList[i];
                                        if (checkedCat[model.comIdColumn + value.level] == value.id && checkedCat[model.comIdColumn] != value.id) {
                                            checkComIds.remove(checkedCat[model.comIdColumn]);
                                            checkComList.splice(i, 1);
                                            i--;
                                        }
                                    }
                                }
                            }
                        },
                        showDetail: function (event, id) {
                            event.stopPropagation();
                            //
                            openComDetailDlg(id);
                        }
                    }
                });
            },
            notityChange: function () {
                // 发生变化时向上传递
                this.$emit('notity-change', this.checkComList);
            },
            getDlgResult() {
                let result = {};
                if (this.checkComList != null && this.checkComList.length > 0) {
                    result.type = 'info';
                    result.data = this.checkComList;
                } else {
                    result.type = 'warn';
                    result.message = '请选择机构';

                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComTreeMultiSelect.vue